import { EditableDate } from './editable-date.interface';
import { PayoffScheduleObservation } from './payoff-schedule-observation.interface';

export const DEFERRED_CALL_EVENT_TYPE = 'NONE';

export interface PayoffSchedule {
  period: number;
  unadjustedPaymentDate?: string | EditableDate;
  adjustedPaymentDate?: string | EditableDate;
  type?: string;
  accrualPeriodStart?: string | EditableDate;
  accrualPeriodEnd?: string | EditableDate;
  accrualPeriodInclusion?: string;
  dayCountFraction?: number;
  dayCountFractionMeta?: {
    value: number;
    dayCount: number[];
    divideBy: number[];
  };
  barrierLevel?: any;
  lowerBarrierLevel?: any;
  upperBarrierLevel?: any;
  rateDeterminationDate?: string | EditableDate;
  observations?: Array<PayoffScheduleObservation>;
  callNoticeDate?: string | EditableDate;
  redemptionAmountPayable_relative?: any;
}
